import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { slashInactiveMessages } from '../../libs/constants'
import { stripQueryString } from '../../libs/historyHelper'
import useSlashInactiveAlert from '../landing/useSlashInactiveAlert'

export default function OnLocationChange() {
  const location = useLocation()
  const rootRef = useRef(document.getElementById('root'))

  useEffect(() => {
    // window.scrollTo(0, 0)
    // eslint-disable-next-line no-unused-expressions
    rootRef.current?.scrollIntoView?.()
  }, [location])

  useSlashInactiveAlert(
    location.pathname.indexOf('/buyer') >= 0
      ? slashInactiveMessages.buyer
      : slashInactiveMessages.seller,
  )

  useEffect(() => {
    stripQueryString(['openExternalBrowser'])
  }, [])

  return null
}
